// Currency formatting utility
export const formatCurrency = (amount, currency = 'USD') => {
  const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    AED: 'د.إ',
    SAR: 'ر.س',
    PKR: '₨',
    INR: '₹'
  };

  const symbol = currencySymbols[currency] || '$';
  
  // Format number with commas for thousands
  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);

  return `${symbol}${formattedNumber}`;
};

export const getCurrencySymbol = (currency = 'USD') => {
  const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    AED: 'د.إ',
    SAR: 'ر.س',
    PKR: '₨',
    INR: '₹'
  };

  return currencySymbols[currency] || '$';
}; 